import { render } from "./ArchaicMap.vue?vue&type=template&id=441fcaf4"
import script from "./ArchaicMap.vue?vue&type=script&lang=js"
export * from "./ArchaicMap.vue?vue&type=script&lang=js"

import "./ArchaicMap.vue?vue&type=style&index=0&id=441fcaf4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__